import { Pipe, PipeTransform } from '@angular/core';
import { formatNumber } from '../misc/sanitizers';

interface NumberFormatterOptions {
  locale?: string;
  digits?: string;
  defaultText?: string;
}

@Pipe({ name: 'formatNumber' })
export class FormatNumberPipe implements PipeTransform {
  transform(value: string | number, options?: NumberFormatterOptions): string {
    const { locale, digits, defaultText } = options || ({} as NumberFormatterOptions);
    return formatNumber(value, locale, digits, defaultText);
  }
}
